import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'

export default createReducer('NARROW', {

    [actions.CHANGE_LAYOUT]: (state, action) => action.layout

})


// WEBPACK FOOTER //
// ./src/reducers/layout.js